export default function SimpleExplanationWindow({text}){
    return <p style={{margin: '10px', marginInlineStart: '30px'}}>
        {text} 
    </p>;
}